const DataModule = [
    {
        path: "/DataModule",
        name: "数据模块",
        component: () =>
            import(
                "../views/DataModule/index.vue"
            ),
        meta: { id: 466, hidden: false, name: "dataModulelxy.dataModule" },
        children: [
            {
                path: "/DataModuleDashboard",
                name: "DataModuleDashboard",
                component: () =>
                    import(
                        "../views/DataModule/dashboard.vue"
                    ),
                meta: { id: 467, hidden: false, name: "performance.dashboard" }
            },
            {
                path: "/PerformanceList",
                name: "PerformanceList",
                component: () =>
                    import(
                        "../views/DataModule/PerformanceList.vue"
                    ),
                meta: { id: 468, hidden: false, name: "dataModulelxy.dataList" }
            },
            {
                path: "/AnomalyStatistics",
                name: "AnomalyStatistics",
                component: () =>
                    import(
                        "../views/DataModule/AnomalyStatistics.vue"
                    ),
                meta: { id: 669, hidden: false, name: "dataModulelxy.anomalyStatistics" }
            }
        ]
    },
];
export default DataModule;